import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Box from '@mui/material/Box';
import reportWebVitals from './reportWebVitals';
// import { ThemeProvider } from '@mui/material/CssBaseline';

import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";
import Home from './screens/home'
import Login from './screens/login'
import Journals from './screens/journals';
import JournalEntries from './screens/journal_entries';
import JournalEntry from './screens/journal_entry';
import NewJournal from './screens/new_journal';
import NewEntry from './screens/new_entry';
import SignUp from './screens/sign_up';
import EarlyAccess from './screens/early_access';
import EarlyAccessConfirmation from './screens/early_access_confirmation';
import Navbar from './screens/components/navbar';
import AboutUs from './screens/about_us';
import Footer from './screens/components/footer';
import { HelmetProvider } from 'react-helmet-async';

const AppLayout = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      <HelmetProvider>
      <Navbar />
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      </HelmetProvider>
    </Box>
);

const router = createBrowserRouter([

  {
    element: <AppLayout />,
    children:[
  {
    path: "/",
    element: <Home/>,
  },
  {
    path: "/early_access_confirmation",
    element: <EarlyAccessConfirmation/>,
  },
  {
    path: "/home",
    element: <Home />
  },
  {
    path: "/login",
    element: (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Login />
    </div>
  )
  },
  {
    path: "/journals",
    element: <Journals />
  },
  {
    path: "/journal_entries",
    element: <JournalEntries />
  },
  {
    path: "/journal_entry",
    element: <JournalEntry/>
  },
  {
    path: "/new_journal",
    element: <NewJournal/>
  },
  {
    path: "/new_entry",
    element: <NewEntry/>
  },
  {
    path: "/signup",
    element: <SignUp/>
  },
  {
    path: "/aboutus",
    element: <AboutUs/>
  },
  {
    path: "/early_access",
    element: <EarlyAccess/>
  }]}
]);


ReactDOM.createRoot(document.getElementById('root')).render(

  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
